import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import useMenu from '@/features/hooks/useMenu';
import useAuth from '@/features/hooks/useAuth';
import { getRoleBasedMenuItems } from '@/utils/menuItems';
import { renderIcon } from '@/utils/iconRenderer';

export default function BottomMenu() {
  const { t } = useTranslation();
  const { selectedComponentHandler } = useMenu();
  const { user } = useAuth();
  const [menuItems, setMenuItems] = useState([]);

  // Bottom Menu için geçerli olan menü öğelerini filtreleyin ve sıralayın
  useEffect(() => {
    if (user) {
      const { authenticationProviderType } = user;
      const items = getRoleBasedMenuItems(authenticationProviderType).map((item) => ({
        ...item,
        name: t(item.name),
      }));
      const bottomMenuItems = items
        .filter((item) => item.isBottomMenu)
        .sort((a, b) => a.isBottomMenuOrder - b.isBottomMenuOrder);

      setMenuItems(bottomMenuItems);
    }
  }, [user, t]);

  return (
    <nav className="flex justify-around mb-0 bg-color-bottom-menu text-color-text w-full  md:hidden">
  {menuItems.slice(0, 5).map((item) => (
    <NavLink
      key={item.id}
      to={item.to}
      className={({ isActive }) =>
        `${item.isCenterIcon
          ? 'relative bottom-2.5 w-[55px] h-[55px] border-2 rounded-full text-[20px] flex items-center justify-center shadow-md transition-all duration-300 ease-in-out bg-color-bottom-menu'
          : 'flex-1 text-center overflow-hidden whitespace-nowrap text-ellipsis'
        } ${isActive ? 'text-color-primary border-color-secondary' : 'text-color-text border-color-primary'} hover:text-color-hover active:text-color-active`
      }
      onClick={() => selectedComponentHandler(item.id)}
    >
      <div className="flex items-center justify-center">
        {renderIcon(item.icon)}
      </div>
      {!item.isCenterIcon && (
        <span className="text-[11px] overflow-hidden whitespace-nowrap text-ellipsis inline-block max-w-[90%]">
          {t(item.name)}
        </span>
      )}
    </NavLink>
  ))}
</nav>

  
  
  );
}
